module.exports = __webpack_public_path__ + "static/media/ptsb.fc9457be.png";